
import { Component, Prop, Vue } from 'vue-property-decorator'
import ProLabelTooltip from '~/components/common/freemium/ProLabelTooltip.vue'
import { isMobile } from '~/lib/utils/utils'
import ReactivateProTooltip from '~/components/common/maintenance/ReactivateProTooltip.vue'
import { TOOLTIP_VIEW, UNLOCK_PRO_BUTTON_CLICK_TOOLTIP } from '~/plugins/mixpanel/events'
import mixpanelEventValues from '~/plugins/mixpanel/values'

type Referer = 'credibility' | 'applicant_count' | 'application_status' | 'automatically_reapply' | '';
type preventOverflow = 'scrollParent' | 'window' | 'viewport';

@Component({
  components: {
    ReactivateProTooltip,
    ProLabelTooltip
  }
})
export default class ProLabel extends Vue {
  @Prop({ type: Number, default: 1 }) size!: number
  @Prop({ type: String }) referrer!: Referer
  @Prop({ type: Boolean, default: true }) showProLabel!: boolean
  @Prop({ type: Boolean, default: true }) pointer!: boolean
  @Prop({ type: String, default: 'scrollParent' }) preventOverflow!: preventOverflow
  @Prop({ type: String, default: '' }) tooltipInitiator: string

  isMobile = true

  mounted() {
    this.isMobile = isMobile()
  }

  get proLabelGray() {
    return this.isMaintenanceMode
  }

  mixpanelTrack(event, referrer) {
    const props = {
      [this.$mixpanel.props.TAB_NAME]: this.$route.params.tabName
    }

    if (referrer) {
      props[this.$mixpanel.props.OPENED_FROM] = referrer
    }

    if (event === UNLOCK_PRO_BUTTON_CLICK_TOOLTIP) {
      props[this.$mixpanel.props.PRO_MODAL_NEW] = mixpanelEventValues[this.$mixpanel.props.PRO_MODAL_NEW]()
    }

    if (event === TOOLTIP_VIEW) {
      props[this.$mixpanel.props.FREEMIUM_STATUSES] = mixpanelEventValues[this.$mixpanel.props.FREEMIUM_STATUSES]()
    }

    this.$mixpanel.track(event, props)
  }

  onShow() {
    this.isMaintenanceMode
      ? this.mixpanelTrack(this.$mixpanel.events.TOOLTIP_VIEW_MAINTENANCE_MODE, this.tooltipInitiator)
      : this.mixpanelTrack(this.$mixpanel.events.TOOLTIP_VIEW, this.tooltipInitiator)
  }

  hide() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  get labelSize():number {
    return Math.max(1, Math.min(this.size, 2))
  }

  get isMaintenanceMode():boolean {
    return this.$auth.user.membership?.isMaintenanceModeHasEffect || this.$auth.user.membership?.isMaintenanceMode
  }
}
